import { render } from "./DataLoading.vue?vue&type=template&id=cb72fba8&scoped=true"
import script from "./DataLoading.vue?vue&type=script&lang=js"
export * from "./DataLoading.vue?vue&type=script&lang=js"

import "./DataLoading.vue?vue&type=style&index=0&id=cb72fba8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb72fba8"]])

export default __exports__